import { apiRequest } from '@common/api/utils';

const BASE_API_URL = '/academy/profile';

function toggleProfileVisibility(hidden) {
  return apiRequest('POST', `${BASE_API_URL}/toggle`, {
    hidden,
  });
}

export default {
  toggleProfileVisibility,
};
